import { DEBUG } from '@devexpress/analytics-core/core/utils/_debug';
import React, { Component } from 'react';
import { Thunderbolt } from 'react-bootstrap-icons';
import { Redirect } from 'react-router-dom';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../GlobalContext';
import * as MySound from '../MySound';
import ModalOK from './CartonisedModalOk'

export class CartonisedSupervisorSignoff extends Component {
    static displayName = CartonisedSupervisorSignoff.name;
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: false,
            sending: false,
            headerTitle: "Supervisor Signoff",
            alertMessage: "",
            passwordText: "",
            usernameText: "",
            staffId: "",
            sourceRoute: props.location.state,
            errorAlert: false,
            errorAlertMsg: ''
        };
        this.history = props.history;
    }

    componentDidMount() {
        this.populateData();
    }

    goto(page, data) {
        this.history.push({
            pathname: page,
            state: data
        });
    }

    renderDropdown(data) {
        return (<select
            className="form-select form-control"
            name="selUsername"
            aria-label=".form-select-lg example"
            onChange={(e) => {
                this.setState({ staffId: e.target.value, passwordText: "" });
            }}
            readOnly={this.state.sending}
        >
            {data.map(row =>
                <option key={row.id} value={row.id}>{row.Staff_Name}</option>
            )}
        </select>)
    }

    render() {

        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : "";

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";
        return (

            <div className="">
                {alertMessage}
                <MyHeading>{this.state.headerTitle}</MyHeading>
                {contents}
                <div className="form-group">
                    <label htmlFor="selUsername">Username</label>
                    {this.renderDropdown(this.state.data)}
                </div>

                <div className="form-group">
                    <label htmlFor="txtPasword">Password</label>
                    <input
                        type="password"
                        className="form-control"
                        name="txtPasword"
                        id="txtPasword"
                        value={this.state.passwordText}
                        onChange={(e) => {
                            this.setState({ passwordText: e.target.value });
                        }}
                        readOnly={this.state.sending}
                    />
                </div>

                <div className="container">
                    <div className="row form-group">
                        <button type="button" className="btn btn-success col-12 mb-2" disabled={this.state.loading} onClick={() => { this.doLogin(); }}>Approve</button>
                    </div>
                </div>
                <div className="container">
                    <div className="row form-group">
                        <button type="button" className="btn btn-danger col-12 mb-2" disabled={this.state.loading} onClick={() => { this.goBack(); }}>Cancel</button>
                    </div>
                </div>

                <ModalOK title='Error' show={this.state.errorAlert} message={this.state.errorAlertMsg} onClickOk={() => { this.setState({ errorAlert: false, errorAlertMsg: '' }); }}  ></ModalOK>

            </div>

        );

    }

    goBack() {
        var sourceRoute = this.state.sourceRoute;
        if (sourceRoute.nextUrl === 'CartonisedChooseShipment') {
            this.goto('CartonisedChooseShipment', null);
        }
        else {
            this.goto(sourceRoute.backUrl, { selectedShipment: sourceRoute.selectedShipment });
        }       
    }

    approve() {
        var sourceRoute = this.state.sourceRoute;
        if (sourceRoute.backUrl === 'CartonisedScanCarton') {
            this.devanComplete();
        }
        if (sourceRoute.backUrl === 'CartonisedUnknownCarton') {
            this.goto('CartonisedConfirmInwards', { selectedShipment: sourceRoute.selectedShipment, supervisorId: this.state.staffId });
        }
    }

    async devanComplete() {
        var sourceRoute = this.state.sourceRoute;
        this.setState({ loading: true });
        const submitRequest = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                ShipmentReference: sourceRoute.selectedShipment.shipment_ref,
                UserId: this.state.staffId,
            })
        };

        const response = await fetch('api/CartonisedInwards/DevanComplete', submitRequest);
        const result = await response.json();
        if (result.success) {
            this.setState({ alertMessage: "", loading: false });
            if (result.data === 0) {
                this.goto('CartonisedConfirmInwards', { selectedShipment: sourceRoute.selectedShipment, supervisorId: this.state.staffId });
            }
            if (result.data > 0) {
                this.goto(sourceRoute.nextUrl, { selectedShipment: sourceRoute.selectedShipment });
            }

            if (result.data < 0) {
                this.setState({ errorAlert: true, errorAlertMsg: result.errorMessage, loading: false });
                MySound.play(MySound.Sound.stop);
            }
        }
        else {
            this.setState({ errorAlert: true, errorAlertMsg: result.errorMessage, loading: false });
            MySound.play(MySound.Sound.stop);
        }

    }


    async doLogin() {
        if (this.state.staffId == "" || this.state.passwordText == "") {
            this.setState({ alertMessage: "Enter username and password" });
            return;
        }

        const response = await fetch(`api/CartonisedInwards/SupervisorApproval?staffId=${this.state.staffId}&password=${this.state.passwordText}`);
        const result = await response.json();
        if (result.success) {
            this.setState({ alertMessage: "" });
            this.approve();
        } else {
            this.setState({ alertMessage: "Incorrect username or password" });
        }
    }

    async populateData() {
        this.setState({ loading: true });
        let url = `api/CartonisedInwards/GetActiveTimeSheetUsers`;
        const response = await fetch(url, {
        });
        const result = await response.json();
        if (result.success) {
            this.setState({
                data: result.data, alertMessage: ""
            });
        }
        else {
            this.setState({ alertMessage: "Incorrect username or password" });
        }

        this.setState({ loading: false });
    }
}

export default CartonisedSupervisorSignoff;